import { ChatLayout } from 'Components/Chat/ChatLayout';
import { ChatNewConversationLayout } from 'Components/Chat/ChatNewConversationLayout';
import { ChatPage } from 'Components/Chat/ChatPage';

import React from 'react';
import { RouteObject } from 'react-router';

const chatRoutes: RouteObject = {
  path: 'chat/*',
  handle: { title: 'Chat' },
  element: <ChatPage />,
  children: [
    {
      path: 'conversations/new',
      handle: { title: 'Start Conversation' },
      element: <ChatNewConversationLayout />,
    },
    {
      path: 'conversations/:conversationId/*',
      handle: { title: 'Conversation' },
      element: (
          <ChatLayout />
      ),
    },
  ],
};

export default chatRoutes;
